module.exports = __webpack_public_path__ + "img/kesh-profile-icon.13d37edb.svg";